// extracted by mini-css-extract-plugin
export default {"tableTitleCell":"Modal_tableTitleCell__suYqg","select":"Modal_select__N2BJX"};